import React, {Component, Fragment} from "react";
import ReactDOM from "react-dom";
import {Link} from "react-router-dom";

class MainPixelogHeaderCard extends Component {

    render() {

        const {dataKey, created_at, type, name} = this.props;

        var year = created_at.substring(2, 4);
        var month = created_at.substring(5, 7);
        var day = created_at.substring(8, 10);

        // ai 이미지경로
        if (type == 1) {
            var imgSrc = `/outputs/txt2img/20${year}-${month}-${day}/${dataKey}.png`;
        } else {
            var imgSrc = `/upload/${year}/${month}/${day}/${dataKey}.png`;
        }

        var headerContainer = document.querySelector('.header-container');
        if (headerContainer !== null) {
            headerContainer.style.backgroundColor = '';
        }

        return (

            <div className="grid-header-item p-1 card-preview-container" style={{"position": "relative"}}>
                <img
                    style={{width: "100%"}}
                    src={imgSrc}
                    className="header-animated-preview-widget"
                    alt={name}
                />
            </div>

        ); //return
    }
}

export default MainPixelogHeaderCard;